import { LPBondsStatsApi } from 'clientSDK';
import dotenv from 'dotenv';
dotenv.config();

const lpBondsStatsApi = new LPBondsStatsApi();

export default {
  getCollectionStats: async (address) => {
    try {
      const responseData = await lpBondsStatsApi.getCollectionStats(address);
      return responseData;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  getActivities: async ({
    collection,
    collections,
    listing = true,
    mint = true,
    sale = true,
    transfer = true,
    burn = true,
    offer = true,
    bid = true,
    skip = 0,
    limit = 50,
    date,
  }) => {
    try {
      const responseData = await lpBondsStatsApi.getActivityStats({
        collection,
        collections,
        listing,
        mint,
        sale,
        offer,
        bid,
        transfer,
        burn,
        skip,
        limit,
        date,
      });
      return responseData;
    } catch (err) {
      console.error(err);
    }
  },

  getUserActivities: async ({
    address,
    collection,
    collections,
    listing = true,
    sale = true,
    offer = true,
    bid = true,
    transfer = true,
    mint = true,
    burn = true,
    skip = 0,
    limit = 50,
    date,
  }) => {
    try {
      const responseData = await lpBondsStatsApi.getUserActivityStats({
        address,
        collection,
        collections,
        listing,
        mint,
        sale,
        offer,
        bid,
        transfer,
        burn,
        skip,
        limit,
        date,
      });
      return responseData;
    } catch (err) {
      console.error(err);
    }
  },

  /**
   * Get all LP Bonds for the current chain with stats and metadata
   * This unified endpoint returns all bond data in one call
   * Now includes grouped data for landing page display
   * @returns {Promise<{totalItems: number, totalGroups: number, chain: string, data: Array, grouped: Array}>}
   */
  getLPBonds: async () => {
    try {
      const responseData = await lpBondsStatsApi.getLPBonds();
      return responseData;
    } catch (err) {
      console.error('Error fetching LP Bonds:', err);
      return { totalItems: 0, totalGroups: 0, chain: '', data: [], grouped: [] };
    }
  },

  /**
   * Get lightweight LP Bonds data for filter dropdowns
   * Returns only essential fields needed for collection filter UI
   * @returns {Promise<{totalItems: number, chain: string, data: Array}>}
   */
  getLPBondsFilter: async () => {
    try {
      const responseData = await lpBondsStatsApi.getLPBondsFilter();
      return responseData;
    } catch (err) {
      console.error('Error fetching LP Bonds filter data:', err);
      return { totalItems: 0, chain: '', data: [] };
    }
  },

  /**
   * Get global stats history (TVL and bond counts over time)
   * @param {Number} days Number of days of history (0 = all-time, default 0)
   * @param {string} chain Chain filter ('all', 'ethereum', 'apechain', 'arbitrum', 'monad')
   */
  getGlobalStatsHistory: async (days = 0, chain = 'all') => {
    try {
      const responseData = await lpBondsStatsApi.getGlobalStatsHistory(days, chain);
      return responseData;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  /**
   * Get current global stats (latest TVL and bond counts)
   * @param {string} chain Chain filter ('all', 'ethereum', 'apechain', 'arbitrum', 'monad')
   */
  getCurrentGlobalStats: async (chain = 'all') => {
    try {
      const responseData = await lpBondsStatsApi.getCurrentGlobalStats(chain);
      return responseData;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  /**
   * Get bonds configuration (single source of truth from backend)
   * Returns APY by level, chain IDs, and all bond pair configurations
   * @returns {Promise<{apyByLevel: Object, chains: Object, pairs: Object}>}
   */
  getBondsConfig: async () => {
    try {
      const responseData = await lpBondsStatsApi.getBondsConfig();
      return responseData;
    } catch (err) {
      console.error('Error fetching bonds config:', err);
      return null;
    }
  },
};
